import { render } from "./Paginate.vue?vue&type=template&id=8c269164&scoped=true"
import script from "./Paginate.vue?vue&type=script&lang=js"
export * from "./Paginate.vue?vue&type=script&lang=js"

import "./Paginate.vue?vue&type=style&index=0&id=8c269164&scoped=true&lang=css"

import exportComponent from "/home/timecard-test/OggiTimeClockSystem/electron/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c269164"]])

export default __exports__